import React, { useContext } from "react";
import { LanguageContext } from "./contexts/LanguageContext";
import { GenericHint } from "./components/GenericHint";

const imgRules = new URL("../img/ID.manual-4.gif", import.meta.url);

export const Hints4 = () => {
    const language = useContext(LanguageContext);

    return (
        <GenericHint
            imgSrc={imgRules.toString()}
            nextRoute="/hints5"
            doText={language.hints4_do_text}
            dontText={language.hints4_dont_text}
        />
    );
}